import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=7290de55&"
import script from "./Home.vue?vue&type=script&lang=js&"
export * from "./Home.vue?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QTable,QInput,QIcon} from 'quasar'
component.options.components = Object.assign({QBtn,QTable,QInput,QIcon}, component.options.components || {})
